// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__qKaon","rootSuccess":"CompleteLink_rootSuccess__1i0-V","rootFailure":"CompleteLink_rootFailure__nzjn-","isDisabled":"CompleteLink_isDisabled__1AfpQ"};